import React from 'react';
import { DrawerControls } from './DrawerControls';
import { UserList } from './UserList';
import { DrawerFooter } from './DrawerFooter';
import { type BemanningUser } from '../hooks/useDraftBemanningDrawer';
import { type UseDraftBemanningReturn } from '@/hooks/useDraftBemanning';

interface DrawerContentProps {
  searchQuery: string;
  showAllUsers: boolean;
  displayList: BemanningUser[];
  loading: boolean;
  error: string | null;
  selectedUsers: Set<number>;
  selectedTalentName: string | null;
  draft: UseDraftBemanningReturn;
  onSearchChange: (value: string) => void;
  onShowAllUsersChange: (showAll: boolean) => void;
  onToggleUser: (userId: number, event?: React.MouseEvent) => void;
  onAddToDraft: () => void;
}

export const DrawerContent: React.FC<DrawerContentProps> = ({
  searchQuery,
  showAllUsers,
  displayList,
  loading,
  error,
  selectedUsers,
  selectedTalentName,
  draft,
  onSearchChange,
  onShowAllUsersChange,
  onToggleUser,
  onAddToDraft,
}) => {
  return (
    <div className="flex-1 overflow-hidden flex flex-col">
      <DrawerControls
        searchQuery={searchQuery}
        showAllUsers={showAllUsers}
        displayListLength={displayList.length}
        selectedUsersCount={selectedUsers.size}
        onSearchChange={onSearchChange}
        onShowAllUsersChange={onShowAllUsersChange}
      />

      {error && (
        <div className="mx-3 mt-3 p-3 bg-destructive/10 border border-destructive/30 rounded-lg text-sm text-destructive">
          {error}
        </div>
      )}

      <UserList
        users={[]}
        displayList={displayList}
        loading={loading}
        showAllUsers={showAllUsers}
        selectedUsers={selectedUsers}
        selectedTalentName={selectedTalentName}
        draft={draft}
        onToggleUser={onToggleUser}
      />

      <DrawerFooter
        isDraftMode={draft.isDraftMode}
        selectedUsersCount={selectedUsers.size}
        onAddToDraft={onAddToDraft}
      />
    </div>
  );
};

